import { useMutation } from '@tanstack/react-query';
import { cancelBooking } from 'stores/queries/booking/booking-queries';

export function useMutationCancelBooking() {
  return useMutation(cancelBooking);
}
